/** @jsxImportSource @emotion/react */
"use client";
import type { Interpolation } from "@emotion/react";
import { numericPercentages, spacing, Text } from "@packages/ui";
import type { ComponentProps, MouseEventHandler } from "react";

import type { MetaData } from "../../lib";
import type { ContentItemProps } from "../ContentItem";
import { ContentItemMetaData } from "../ContentItemMetadata";

const contentTextContainerStyles: Interpolation = {
  alignItems: "flex-start",
  display: "flex",
  flexDirection: "column",
  gap: spacing.xs,
  overflow: "hidden",
  padding: spacing.none,
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  width: numericPercentages[100],
};

const titleDescriptionContainerStyles: Interpolation = {
  display: "flex",
  flexDirection: "column",
  gap: spacing.xxs,
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  width: numericPercentages[100],
};

const contentTextContainerXXSStyles: Interpolation = {
  gap: spacing.t,
};

const contentTextStyles: Interpolation = {
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  width: numericPercentages[100],
};

export const ContentItemContent = ({
  title,
  description,
  metaData,
  size,
  onPlay,
  ...props
}: Pick<ContentItemProps, "title" | "description" | "metaData" | "size"> & {
  metaData?: MetaData;
  onPlay?: MouseEventHandler<HTMLButtonElement>;
} & Omit<ComponentProps<"div">, "title" | "onPlay">) => (
  <div
    css={[
      contentTextContainerStyles,
      size === "xxs" && contentTextContainerXXSStyles,
    ]}
    {...props}
  >
    <div css={titleDescriptionContainerStyles}>
      <Text
        type="title"
        size={size === "xxs" ? "xs" : "m"}
        css={contentTextStyles}
      >
        {title}
      </Text>
      {description && (
        <Text
          type={size === "xxs" ? "detail" : "body"}
          size={"s"}
          css={contentTextStyles}
        >
          {description}
        </Text>
      )}
    </div>
    {metaData && (
      <ContentItemMetaData icon={metaData.icon} text={metaData.text} />
    )}
  </div>
);
